import Typography from "@mui/material/Typography";
import {useEffect} from "react";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {Box} from "@mui/material";
import config from "../config";

const PaymentSuccess = () => {
    useEffect(() => {
        if (window.opener){
            window.opener.postMessage(
                {type: 'STRIPE_CHECKOUT_SUCCESS'},
                config.FRONTEND_ORIGIN
            );
        } else {
            window.location.href = 'sbobbi://checkout/success';
        }

        setTimeout(() => {
            window.close();
        }, 4000);
    }, []);
    return <>
        <Box display='flex' pt={10} flexDirection='column' alignItems='center' justifyContent='center'>
            <CheckCircleIcon sx={{fontSize: '4rem'}} color={'success'} />
            <Typography textAlign='center' mt={2} color={"success"} variant='h4'>Pagamento andato a buon fine!</Typography>
            <Typography textAlign='center' variant='h6'>Questa pagina si chiuderà automaticamente tra qualche secondo.</Typography>
            <Typography mt={4} color={"#999"} variant='body2'>Stai per tornare su Sbobbi!</Typography>
        </Box>
    </>
}

export default PaymentSuccess;